var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#FFEFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7335 17.6832C43.8822 16.8315 42.8715 16.1559 41.7591 15.695C40.6467 15.2341 39.4543 14.9968 38.2502 14.9968C37.046 14.9968 35.8537 15.2341 34.7412 15.695C33.6288 16.1559 32.6181 16.8315 31.7668 17.6832L30.0002 19.4499L28.2335 17.6832C26.514 15.9637 24.1819 14.9977 21.7502 14.9977C19.3185 14.9977 16.9863 15.9637 15.2668 17.6832C13.5474 19.4027 12.5814 21.7348 12.5814 24.1665C12.5814 26.5983 13.5474 28.9304 15.2668 30.6499L17.0335 32.4165L30.0002 45.3832L42.9668 32.4165L44.7335 30.6499C45.5852 29.7986 46.2608 28.7879 46.7217 27.6755C47.1826 26.563 47.4199 25.3707 47.4199 24.1665C47.4199 22.9624 47.1826 21.77 46.7217 20.6576C46.2608 19.5452 45.5852 18.5345 44.7335 17.6832V17.6832Z",
    stroke: "#E21010",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartBg);
export default __webpack_public_path__ + "static/media/icon_heart_bg.53090598dded925f70a41e3c57e7d397.svg";
export { ForwardRef as ReactComponent };